import { render, staticRenderFns } from "./ExpandedContentDetail.vue?vue&type=template&id=275e7f2c&lang=pug&"
import script from "./ExpandedContentDetail.vue?vue&type=script&lang=ts&"
export * from "./ExpandedContentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports